import React from 'react';
import { ListBoxComponent } from './ListBoxComponent';
import {
  usePaginationContext,
  useListLayoutContext,
} from './autoComplete.helper';

const PaginatedListBoxComponent = React.forwardRef<HTMLDivElement, any>(
  (props, ref) => {
    const paginationContext = usePaginationContext();
    const { maxHeight, rowHeight } = useListLayoutContext();
    return (
      <ListBoxComponent
        {...props}
        ref={ref as React.LegacyRef<HTMLDivElement>}
        hasMore={paginationContext.hasMore}
        isFetching={paginationContext.isFetching}
        loadMore={paginationContext.loadMore}
        maxHeight={maxHeight}
        rowHeight={rowHeight}
      />
    );
  },
);
PaginatedListBoxComponent.displayName = 'PaginatedListBoxComponent';

export default PaginatedListBoxComponent;
